import React from "react";
import { Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InicioOriginal from "./pages/aaff/diseños/original/Inicio";
import InicioLegalia from "./pages/aaff/diseños/legalia/Inicio";
import Comunidades from "./pages/aaff/Comunidades";
import Comunidad from "./pages/aaff/Comunidad";
import Proveedores from "./pages/aaff/Proveedores";
import Proveedor from "./pages/aaff/Proveedor";
import AAFF from "./pages/aaff/AAFF";
import AAFFInformes from "./pages/admin/AAFFInformes";
import Ventas from "./pages/general/Ventas";
import InformeSituacionRiesgosWeb from "./pages/admin/informeSituacionRiesgosWeb";
import DatosPerfil from "../components/perfil/datosPerfil";
import Oficinas from "./pages/aaff/Oficinas";
import OficinasLegalia from "./pages/aaff/diseños/legalia/Oficinas";
import IANormativa from "./pages/aaff/diseños/legalia/IANormativa";
import LAEAI from "./pages/aaff/LAEAI";
// import IAJuridica from "./pages/aaff/diseños/legalia/IAJuridica"; // IA Jurídica oculta para todos los planes (a petición)
import { Boxes, Icon, Wrench, Building2, MapPin } from "lucide-react";
import Instalaciones from "./pages/kae/instalaciones/Instalaciones";
import InstalacionesLegalia from "./pages/aaff/diseños/legalia/Instalaciones";
import Instalacion from "./pages/kae/instalaciones/Instalacion";
import InstalacionLegalia from "./pages/aaff/diseños/legalia/Instalacion";
import Edificios from "../icons/edificios.svg";
import { houses } from '@lucide/lab';
import {
  FileChartLine
} from 'lucide-react';


export function RouteBundle(props) {
  return (
    <Routes>
      <Route path="/" element={props.user?.tieneLegalia ? <InicioLegalia /> : <InicioOriginal />} />
      <Route path="comunidades" element={<Comunidades />} />
      <Route path="comunidades/:nif" element={<Comunidad />} />
      {(props.user?.gruposServicios?.includes(1) || props.user?.parent === true) &&
        <>
          <Route path="proveedores" element={<Proveedores />} />
          <Route path="proveedores/:nif" element={<Proveedor />} />
        </>
      }
      {props.user?.parent === true &&
        <Route path="oficinas" element={props.user?.tieneLegalia ? <OficinasLegalia /> : <Oficinas />} />
      }
      {props.user?.tieneKae &&
        <>
          <Route path="instalaciones" element={props.user?.tieneLegalia ? <InstalacionesLegalia /> : <Instalaciones />} />
          <Route path="instalaciones/:id" element={props.user?.tieneLegalia ? <InstalacionLegalia /> : <Instalacion />} />
        </>
      }
      <Route path="/aaff-informes" element={<AAFFInformes />} />
      <Route path="/informe-riesgos/:nif" element={<InformeSituacionRiesgosWeb />} />
      <Route path="aaff" element={props.user?.tieneLegalia ? <Navigate to="/perfil" replace /> : <AAFF />} />
      <Route path="/servicios" element={<Ventas />} />
      <Route path="/perfil" element={<DatosPerfil />} />
      {/* Tu IA Normativa (asistente propio, solo con LegalIA). La anterior (servicio externo) sigue en /ia-normativa-vieja,
          fuera del menú. Las rutas antiguas redirigen conservando ?pregunta= (enlaces ya guardados) */}
      <Route path="/ia-normativa" element={props.user?.tieneLegalia ? <LAEAI /> : <Navigate to="/" replace />} />
      <Route path="/ia-normativa-vieja" element={<IANormativa />} />
      <Route path="/ia-normativa-nueva" element={<RedirigirConBusqueda a="/ia-normativa" />} />
      <Route path="/laeai" element={<RedirigirConBusqueda a="/ia-normativa" />} />
      {/* IA Jurídica oculta para todos los planes (a petición). Reactivar restaurando esta ruta. */}
      <Route path="/ia-juridica" element={<Navigate to='/' replace />} />
      <Route path="*" element={<Navigate to='/' replace/>}/>
    </Routes>
  );
}
{/*  */ }
const refrescoLocal = () => {
  localStorage.setItem("hasReloaded", "true");
}

export function MenuLinksClientes(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/comunidades" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <Icon iconNode={houses} stroke-width="1.5" alt={t('clients.communities')} />{t('clients.communities')}
          </div>
        </NavLink>
      </li>
      {props.user?.parent === true &&
        <li>
          <NavLink activeclassname="active" to="/oficinas" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Building2 stroke-width="1.5" alt={t('clients.offices')} />{t('clients.offices')}
            </div>
          </NavLink>
        </li>
      }
      {(props.user?.gruposServicios?.includes(1) || props.user?.parent === true) &&
        <li>
          <NavLink activeclassname="active" to="/proveedores" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Wrench stroke-width="1.5" alt={t('clients.suppliers')} />{t('clients.suppliers')}
            </div>
          </NavLink>
        </li>
      }
      <li>
        <NavLink activeclassname="active" to="/servicios" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <Boxes stroke-width="1.5" width="35px" alt={t('clients.services')} />{t('clients.services')}
          </div>
        </NavLink>
      </li>
    </>
  )
}
export function MenuLinksKae(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/instalaciones" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <MapPin stroke-width="1.5" alt={t('kae.installations')} />{t('kae.installations')}
          </div>
        </NavLink>
      </li>
    </>
  )
}
export function MenuLinksListado(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/aaff-informes" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <FileChartLine stroke-width="1.5" alt={t('reports.caeReports')} />{t('reports.caeReports')}
          </div>
        </NavLink>
      </li>
    </>
  )
}

/** Redirige a `a` conservando la query (?pregunta=...) */
function RedirigirConBusqueda({ a }) {
  const { search } = useLocation();
  return <Navigate to={`${a}${search}`} replace />;
}
